import { useMutation, useQueryClient } from '@tanstack/react-query'

import { UsersService } from '../lib/users.service'
import { INVITES_LIST_QUERY_KEY } from './useInvites'

export const useRepeatInvite = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (id: string) => {
      return UsersService.repeatInvite(id)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [INVITES_LIST_QUERY_KEY]
      })
    }
  })
}
